import catalogos from './catalogos/catalogos'
import sistema from "./sistema/sistemaSICSEN";

const sicsen = {
  catalogos: catalogos,
  sistema: sistema  
}

export default sicsen


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICSEN/SICSENapi.js
// module id = null
// module chunks = 